interface PromiseFulfilledResult<T> {
    status: "fulfilled";
    value: T;
}

interface PromiseRejectedResult {
    status: "rejected";
    reason: any;
}

export function allSettled<T>(promises: Promise<T>[]) {
    if (!Array.isArray(promises)) {
        throw new TypeError('Expected an array of promises');
    }

    if (Promise.allSettled) {
        return Promise.allSettled(promises);
    }

    const wrapperPromises = promises.map(promise => {
        const result = Promise.resolve(promise)
            .then(value => ({ status: 'fulfilled', value }) as PromiseFulfilledResult<T>)
            .catch(reason => ({ status: 'rejected', reason }) as PromiseRejectedResult);

        return result;
    });

    return Promise.all(wrapperPromises);
};
